export default "__VITE_ASSET__5e59f473__"